import { useAtomValue } from "jotai";
import { useQuery } from "@tanstack/react-query";

import { queriesEnabledAtom, tenantIDAtom } from "../../../atoms/GlobalAtoms";
import TenantAPI from "../../api/TenantAPI";
import { useParams } from "react-router-dom";

const useRecord = ({
  moduleAPIName,
  recordID,
  enabled,
  fields,
}: {
  moduleAPIName: string | undefined;
  recordID: string | undefined;
  enabled?: boolean;
  fields?: string[]; // Optionally Project fields
}) => {
  const params = useParams();
  const queriesEnabled = useAtomValue(queriesEnabledAtom);
  const isShared = window.location.pathname.includes("/shared");
  const tenantID = useAtomValue(tenantIDAtom) || params?.tenantID;

  const queryKey: Array<string | undefined | null | string[]> = [
    tenantID,
    "record",
    moduleAPIName,
    recordID,
  ];

  Array.isArray(fields) && queryKey.push(fields);

  const record = useQuery({
    queryKey: queryKey,
    queryFn: () =>
      TenantAPI.getRecordByID(moduleAPIName!, recordID!, fields).then(
        (data) => data.data.data.data
      ),
    enabled: !!moduleAPIName && !!recordID && queriesEnabled && enabled,
  });

  return {
    record: record.data,
    recordLoading: record.isLoading || (!queriesEnabled && !isShared),
  };
};

export default useRecord;
